import { useDispatch, useSelector } from "react-redux";

import { useContactSearchResult } from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactSearchResult";
import { selectIsContactsFullAccess } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

import ExportAllContactsButton from "../../components/ContactsTableActionsPanel/ExportActionButton/ExportAllContactsButton";
import { useContactsFlowStrategy } from "../../context/ContactsFlowContext";
import { exportAllRevealedContactsForLeadsToExcelThunk } from "../../store/effects";
import { selectIsBeingExportedToExcel } from "../../store/selectors";

const LeadsSearchExportAllContactsButtonContainer = () => {
    const dispatch = useDispatch();

    const isBeingExportedToExcel = useSelector(selectIsBeingExportedToExcel);
    const isContactsFullAccess = useSelector(selectIsContactsFullAccess);

    const contactsFlowStrategy = useContactsFlowStrategy();

    const { isLoading } = useContactSearchResult();

    const isDisabled = !isContactsFullAccess || isLoading || isBeingExportedToExcel;

    function handleClick() {
        void dispatch(exportAllRevealedContactsForLeadsToExcelThunk(contactsFlowStrategy.dataSource.exportExcel));
    }

    return (
        <ExportAllContactsButton
            isDisabled={isDisabled}
            isLoading={isBeingExportedToExcel}
            onClick={handleClick}
        />
    );
};

export default LeadsSearchExportAllContactsButtonContainer;
